import React from 'react'
import Typography from '@material-ui/core/Typography'
export default function() {
  return <Typography component="h1">Page Not Found</Typography>
}
